import { NavLink } from "react-router-dom";
import "./NavMain.scss";
import Logo from "../../elements/SVG/LogoSvg";
import useScreenSize from "../../screenSize";
import HamburgerMenu from "../../elements/HamMenu";
import Navigation from "../Navigation";
import { useGlobalContent } from "../../context/GlobalContext";

const NavMain = () => {
  let screenSize = useScreenSize();
  const { menuItems } = useGlobalContent();

  return (
    <header>
      {screenSize.width <= 768 ? (
        <HamburgerMenu />
      ) : (
        <nav className="navMain">
          <NavLink className="logo" to="/">
            <Logo />
          </NavLink>

          <ul className="list">
            <Navigation items={menuItems} />
          </ul>
        </nav>
      )}
    </header>
  );
};

export default NavMain;
